import { DemandStatus } from 'entities/demand';

export const DEFAULT_STATUS_VALUE: DemandStatus = 'ACTIVE';

export const CREATION_DATE_FORMAT = 'DD.MM.YYYY';

export const PAGE_SIZE = 100;
export const DEFAULT_SORTING = 'statusOrder,desirableDate,asc';
